function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.a{opacity:0;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-90.269 -595)"
}, /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 27.3,
  height: 27.3,
  transform: "translate(90.269 595)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(88.019 592)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M30.732,10.8a1.038,1.038,0,0,0-.565.164l-5.258,3.319a.52.52,0,0,0-.243.438v4.62a.52.52,0,0,0,.243.438L30.167,23.1a1.092,1.092,0,0,0,.565.164H32a.518.518,0,0,0,.523-.517V11.317A.521.521,0,0,0,32,10.8Z",
  transform: "translate(-3.038 -0.244)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M16.929,24.561H5.38a3.14,3.14,0,0,1-3.13-3.124V12.124A3.135,3.135,0,0,1,5.374,9H16.923a3.135,3.135,0,0,1,3.124,3.124V21.43A3.127,3.127,0,0,1,16.929,24.561Z"
})));

function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.3,
    height: 27.3,
    viewBox: "0 0 27.3 27.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.518d4c7d.svg";
export { ForwardRef as ReactComponent };